import { isLocal } from '../env-checks'

export const getNewsletterSignupApiUrl = () => {
  // run the paperboy app in your local for this to work
  if (isLocal()) {
    return 'http://localhost:4000/newsletter/signup'
  }

  return '/newsletter/signup'
}
